/**
 * @typedef {Object} DynamicConfigOptions
 * @property {boolean} [disableCache]
 */

function getConfigUrlFromQuery() {
  const query = new URLSearchParams(window.location.search);
  return query.get('configUrl');
}

/**
 * @param {string} configUrl
 */
function getCacheBustedUrl(configUrl) {
  const cacheBustedUrl = new URL(configUrl, window.location.origin);
  cacheBustedUrl.searchParams.set('_cb', `${Date.now()}`);
  return cacheBustedUrl.toString();
}

/**
 * @param {boolean} disableCache
 * @returns {RequestInit}
 */
function getFetchOptions(disableCache) {
  if (!disableCache) {
    return /** @type {RequestInit} */ ({
      cache: 'default',
    });
  }

  return /** @type {RequestInit} */ ({
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });
}

/**
 * @param {{dangerouslyUseDynamicConfig?: {enabled?: boolean, regex?: RegExp}}} config
 * @param {DynamicConfigOptions} [options]
 */
const loadDynamicConfig = async (config, options = {}) => {
  const { disableCache = false } = options;
  const useDynamicConfig = config?.dangerouslyUseDynamicConfig;

  if (!useDynamicConfig?.enabled) {
    return null;
  }

  const configUrl = getConfigUrlFromQuery();
  if (!configUrl) {
    return null;
  }

  const regex = useDynamicConfig.regex;
  if (!regex?.exec(configUrl)) {
    return null;
  }

  const targetConfigUrl = disableCache ? getCacheBustedUrl(configUrl) : configUrl;
  const response = await fetch(targetConfigUrl, getFetchOptions(disableCache));
  return response.json();
};

export default loadDynamicConfig;
